module.exports = __webpack_public_path__ + "static/media/28_A.30e822a4.png";